import React from 'react';
import { motion } from 'framer-motion';
import { ScrollButton } from './Shared';
export const Hero = () => {
  return <section className="relative overflow-hidden" data-id="element-78">
      <div className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-8 min-h-[100svh] sm:min-h-0 flex flex-col justify-center py-4 sm:pt-16 sm:pb-16" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center w-full" data-id="element-80">
          {/* Eyebrow */}
          <p className="text-brand-terracotta font-semibold text-[10px] sm:text-sm tracking-[0.2em] uppercase mb-2 sm:mb-5" data-id="element-81">
            CLASS ROOM · PILATES 360
          </p>

          {/* Headline */}
          <h1 className="text-[26px] leading-[1.1] sm:text-5xl md:text-6xl font-serif font-bold text-brand-charcoal sm:leading-[1.05] mb-3 sm:mb-10" data-id="element-82">
            Todo tu año de Pilates resuelto de una vez.
          </h1>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="mb-3 sm:mb-10" data-id="element-83">
            <img src="https://cdn.magicpatterns.com/uploads/rJfMVNXjcQCbjdXgomPHaR/267.png" alt="Megapack Pilates 360" loading="eager" fetchPriority="high" decoding="async" width="600" height="600" className="mx-auto h-[42vh] sm:h-auto sm:w-full sm:max-w-md object-contain" data-id="element-84" />
          </motion.div>

          {/* Description */}
          <p className="text-xs sm:text-lg text-gray-600 leading-snug sm:leading-relaxed mb-3 sm:mb-8 max-w-md mx-auto px-2" data-id="element-85">
            Pack Completo PILATES 360 — El sistema completo de sesiones y
            planificación para el profesor de Pilates
          </p>

          {/* Pill Badges */}
          <div className="flex flex-wrap justify-center items-center gap-1.5 sm:gap-3 mb-3 sm:mb-8" data-id="element-86">
            <span className="bg-white border border-brand-sand shadow-sm rounded-full px-3 py-1.5 sm:px-4 sm:py-2 text-[11px] sm:text-sm font-medium text-brand-charcoal whitespace-nowrap" data-id="element-87">
              📄 PDF
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-88">|</span>
            <span className="bg-white border border-brand-sand shadow-sm rounded-full px-3 py-1.5 sm:px-4 sm:py-2 text-[11px] sm:text-sm font-medium text-brand-charcoal whitespace-nowrap" data-id="element-89">
              ⚡ Acceso Inmediato
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-90">|</span>
            <span className="bg-white border border-brand-sand shadow-sm rounded-full px-3 py-1.5 sm:px-4 sm:py-2 text-[11px] sm:text-sm font-medium text-brand-charcoal whitespace-nowrap" data-id="element-91">
              📚 12 Tomos + 6 Bonus
            </span>
          </div>

          {/* CTA */}
          <ScrollButton className="w-full bg-brand-terracotta hover:bg-brand-terracotta-dark text-white text-sm sm:text-lg font-bold py-3.5 sm:py-4 px-6 sm:px-8 rounded-2xl shadow-lg shadow-brand-terracotta/30 transition-all transform hover:-translate-y-0.5 inline-flex items-center justify-center gap-2" data-id="element-92">
            💪 QUIERO MI PILATES 360 AHORA
          </ScrollButton>

          {/* Trust Line */}
          <div className="mt-2.5 sm:mt-5 flex flex-wrap justify-center items-center gap-x-2 gap-y-1 sm:gap-x-3 sm:gap-y-2 text-[10px] sm:text-sm text-gray-600" data-id="element-93">
            <span className="flex items-center gap-1" data-id="element-94">🛡️ Garantía 7 días</span>
            <span className="text-gray-300" data-id="element-95">|</span>
            <span className="flex items-center gap-1" data-id="element-96">🔒 Pago seguro</span>
            <span className="text-gray-300" data-id="element-97">|</span>
            <span className="flex items-center gap-1" data-id="element-98">
              💳 Tarjetas y transferencia
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
};